export default "__VITE_ASSET__qwXmyp6H__"